// Boot-fase-signal for auth-shell (WI 2118).
//
// Under `main.js`-bootstrap finnes ingen user gesture. Et token-popup-fallback
// der blokkeres taust av nettleseren, og MSAL venter ut sin popup-bridge-timeout
// (B2C-provideren: opptil 10 min) → `app.mount('#app')` kalles aldri → appen blir
// stående på «Starter ICS…»-spinneren for alltid.
//
// `getShellAccessTokenSilentOrPopup` leser dette flagget og kjører silent-only så
// lenge appen ikke er montert. `main.js` kaller `markAppInteractive()` rett etter
// `app.mount('#app')`, der en ekte user gesture (og dermed popup) er mulig.

let appInteractive = false;

/** Kalles av `main.js` rett etter `app.mount('#app')`. */
export function markAppInteractive (): void {
  appInteractive = true;
}

/** True når appen er montert og interaktiv popup-pålogging er trygt. */
export function isInteractiveAuthAllowed (): boolean {
  return appInteractive;
}

/** Test-only: nullstill boot-fase-state mellom tester. */
export function _resetBootPhaseForTests (): void {
  appInteractive = false;
}
